import React, { useState } from "react";
import { signInWithPopup, getIdToken } from "firebase/auth";
import { auth, googleProvider } from "../../config/firebase";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const GoogleSignIn = ({
  disabled = false,
  mode = "login",
  buttonText,
  children,
}) => {
  const [loading, setLoading] = useState(false);
  const { googleRegister, googleLogin } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    if (loading || disabled) return;

    try {
      setLoading(true);

      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const idToken = await getIdToken(user, true);

      let authResult;
      if (mode === "register") {
        authResult = await googleRegister({ idToken });
      } else {
        authResult = await googleLogin({ idToken });
      }

      if (authResult.success) navigate("/");
    } catch (error) {
      console.error("Google sign-in error:", error);
      toast.error("Failed to sign in with Google.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={handleGoogleSignIn}
      style={{ cursor: disabled || loading ? "not-allowed" : "pointer" }}
    >
      {loading ? (
        <div className="spinner" style={{ width: 24, height: 24 }}></div>
      ) : (
        children // 👈 THIS FIXES EVERYTHING
      )}
    </div>
  );
};

export default GoogleSignIn;
